/* AUTAVEX — кольори: Comfort свої, Premium — базові */
(function(){
var D=window.AVO;if(!D)return;
var V='?v=1786366532';

/* Comfort — турецька екошкіра */
var COL_C=[
 ['\u0427\u043e\u0440\u043d\u0438\u0439','#1F2123','4C367C2A-DB97-4F63-AAF6-1EA2A77AA1C6.webp'+V],
 ['\u0421\u0456\u0440\u0438\u0439','#7E8388','IMG-3671.webp?v=1786366871'],
 ['\u0421\u0432\u0456\u0442\u043b\u043e-\u0441\u0456\u0440\u0438\u0439','#B7BBBE','5FD74891-E62B-430F-9F90-8D41889C2202.webp'+V],
 ['\u0411\u0456\u043b\u0438\u0439','#F2F0EA','IMG-3651.webp?v=1786366400'],
 ['\u0411\u0435\u0436\u0435\u0432\u0438\u0439','#CDB595','IMG-3650.webp?v=1786366392'],
 ['\u041e\u0445\u0440\u0430','#C08A2E','07236F03-C53C-4222-A6CD-73D8F372676F.webp'+V],
 ['\u0420\u0443\u0434\u0438\u0439','#A9541F','F4F05DD3-3843-4EEF-80C2-7CE50FE97D3A.webp'+V],
 ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#6B4A33','B0FA06A0-272A-433A-B40C-C4B2FCE3FFC2.webp'+V],
 ['\u0428\u043e\u043a\u043e\u043b\u0430\u0434','#4A3327','EA084508-F355-4A89-9695-0A671769FED7.webp'+V],
 ['\u0411\u043e\u0440\u0434\u043e\u0432\u0438\u0439','#6E2733','452BF7E2-3719-4B39-9758-63E14A7ABB6B.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0441\u0456\u0440\u0438\u043c','#3A3E42','BAFA7F51-CE99-4B8A-985E-BF768C30CE4A.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0456\u043b\u0438\u043c','#2B2D2F','72798A33-F98B-4E0C-89AC-54BAD3E6888D.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0435\u0436\u0435\u0432\u0438\u043c','#3A3128','IMG-3670.webp?v=1786366871'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u043a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u043c','#33261E','2C8AF4EC-EBF7-4DBF-AC2C-6FA38424F70C.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u043c','#3A1D20','973A873E-BB1B-47AE-922F-118FA43FF5C5.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0436\u043e\u0432\u0442\u0438\u043c','#3A3320','323082AC-4888-47BF-9407-E035BE9F24BB.webp'+V],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0441\u0438\u043d\u0456\u043c','#20293A','70D6FCC4-F177-4191-9158-5E0525274EC6.webp'+V]
];
/* Premium — німецька екошкіра (як було) */
var COL_P=D.COL.slice();

D.COL=COL_C;
function swap(cat){D.COL=(cat===1?COL_P:COL_C)}
document.addEventListener('click',function(e){
  var b=e.target.closest('#ogCats button');
  if(b)swap(+b.dataset.cat);
},true);

/* нитки — без дублів, 24 кольори */
D.THR=[
 ['\u0427\u043e\u0440\u043d\u0430','#1F2123'],['\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0430','#4C5053'],['\u0421\u0432\u0456\u0442\u043b\u043e-\u0441\u0456\u0440\u0430','#B4B9BC'],
 ['\u0411\u0456\u043b\u0430','#F2F0EA'],['\u0421\u043b\u043e\u043d\u043e\u0432\u0430 \u043a\u0456\u0441\u0442\u043a\u0430','#E6DFCB'],['\u0411\u0435\u0436\u0435\u0432\u0430','#C9B18B'],
 ['\u0417\u043e\u043b\u043e\u0442\u0438\u0441\u0442\u0430','#C79A3C'],['\u0416\u043e\u0432\u0442\u0430','#D2A916'],['\u041e\u0440\u0430\u043d\u0436\u0435\u0432\u0430','#D2691B'],
 ['\u0427\u0435\u0440\u0432\u043e\u043d\u0430','#A8232B'],['\u0411\u043e\u0440\u0434\u043e\u0432\u0430','#6E2733'],['\u0420\u043e\u0436\u0435\u0432\u0430','#C4788F'],
 ['\u0424\u0443\u043a\u0441\u0456\u044f','#B33C86'],['\u0424\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0430','#6B4A8C'],['\u041b\u0430\u0432\u0430\u043d\u0434\u043e\u0432\u0430','#8E86B8'],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0438\u043d\u044f','#1E2C48'],['\u0421\u0438\u043d\u044f','#2E5A8C'],['\u0413\u043e\u043b\u0443\u0431\u0430','#7FA6C4'],
 ['\u0411\u0456\u0440\u044e\u0437\u043e\u0432\u0430','#2E8B84'],['\u0417\u0435\u043b\u0435\u043d\u0430','#33613D'],['\u0425\u0430\u043a\u0456','#6E6B47'],
 ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0430','#6B4A33'],['\u0417\u043e\u043b\u043e\u0442\u043e','#C9A227',1],['\u0421\u0440\u0456\u0431\u043b\u043e','#B9BDC2',1]
];
})();
